"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fullJitter(delay) {
    var jitteredDelay = Math.random() * delay;
    return Math.round(jitteredDelay);
}
exports.fullJitter = fullJitter;
//# sourceMappingURL=full.jitter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exponential-backoff/dist/jitter/full/full.jitter.js
// module id = 318
// module chunks = 88 89